<style>
	.bgss {
		background-color: #fff;width:100%; 
	}
 
 
.draw-enter-active, .draw-leave-active {
     transition: opacity 1s;
}
.draw-enter, .draw-leave-to /* .fade-leave-active below version 2.1.8 */ {
     opacity: 0;
}
.top_area{width:100%;height:4vw;position:fixed;top:1vw;left:0; }
.top_area img{display:block;float:left;height:4vw; }
.tabbar7{width:84vw;height:4vw;background:url(../../assets/images/tabbar_bg.png) center center; border-radius:.5vw;
float:left;margin-left:2.5vw;background-size:105% 105%;  }
.tabbar7 span{display:block;float:left;line-height:4vw;font-size:1.4vw;}
.tabbar7 span.pos{ padding:0 1vw;}
.tabbar7 span.floder{ color:#666;}
 
.tabbar7 span.rights{background:url(../../assets/images/right.png) no-repeat;width:2vw;
height:4vw;background-position:center center;background-size:2vw;}
 
.steps{width:84vw;height:6vw;margin:0;padding:0;overflow:hidden; 
border-bottom:#f3f7f8 solid 1px;margin-top:7vw;position:relative;margin-left:7vw;
 }
.steps ul{width:65vw;height:3.5vw; float:left;box-sizing:border-box;box-sizing:border-box;position:absolute;top:0;cursor:pointer;}
.steps ul li{float:left;padding: 0 1vw;height:3.5vw;line-height:3.5vw;font-size:1.4vw;box-sizing:border-box;text-align:center;}
.steps ul li.on{border-bottom:#3268ff solid 0.15vw;color:#3268ff; }
.steps ul li:hover{background:#f1f1f1; }


.new_template4{width:12vw;float:right;height:3vw;border:#4471ff solid 1px;margin-top:1.5vw;border-radius:.5vw;cursor:pointer;}
.new_template4 img{width:2vw;margin-top:.5vw;margin-left:.5vw;display:block;float:left;}
.new_template4 span{display:block;float:left;width:9vw;text-align:center;line-height:3vw;font-size:1.2vw;font-weight:bold;
  color:#4471ff;}
.templates{width:84vw; margin-top:1vw;height:28vw;}
.template_box2{width:40vw;height:13vw; position:relative;background: url(../../assets/images/unselected2.png) no-repeat;background-size:100% 100%;border-radius:.5vw;
margin-top:1vw;cursor:pointer;padding:0 1vw;float:left;}
.pull-left{float:left;}
.pull-right{float:right;}

.template_box2 p{position:absolute;font-size:1.2vw;width:33vw;left:2vw;top:1.5vw;line-height:2vw;height:10vw;overflow:hidden;
display: -webkit-box;
-webkit-box-orient: vertical;
-webkit-line-clamp:5;
overflow: hidden;}
.pass{width:2.4vw;height:2.4vw;position:absolute;top:2.2vw;right:2vw;background:#32ad37;border-radius:2.4vw;}
.pass img{width:1.4vw;display:block;margin:0 auto;margin-top:.5vw;}

.template_box2 span{display:block;position:absolute;}
.template_box2 span.msg1{font-size:1.2vw;right:0;top:5vw;color:#32ad37;width:5vw;margin-right:.7vw;}
.template_box2 span.msg2{font-size:1.2vw;right:0;top:5vw;color:#FA9D3C;width:4.4vw;margin-right:.7vw;}
.template_box2 span.edit{font-size:1.2vw;right:2.5vw;top:7vw;color:#3465ff;width:3vw;margin-right:.7vw;text-decoration:underline;text-align:left;}
.template_box2 span.del{font-size:1.2vw;right:0;top:7vw;color:#3465ff;width:3vw;margin-right:.7vw;text-decoration:underline;text-align:right;}

.selected{background: url(../../assets/images/selected2.png) no-repeat;background-size:100% 100%;}
.pages{margin:0 auto;padding:0;overflow:hidden;width:84vw;height:3.5vw; margin-top:1vw;} 
/*.pre{width:2.5vw;height:2.5vw;border:#e0e0e0 dotted 1px;float:left;box-sizing:border-box;}
.pre img{width:2vw;margin-top:.25vw;margin-left:.2vw;}
 
.next{width:2.5vw;height:2.5vw;border:#e0e0e0 dotted 1px;float:left;box-sizing:border-box;margin-left:1vw;}
.next img{width:2vw;margin-top:.25vw;margin-left:.25vw;}*/

.pre{width:2.5vw;height:2.5vw;border:#e0e0e0 dotted 1px;float:left;box-sizing:border-box;background: #fff;
background-image: url(../../assets/images/pre2.png);background-size: 2vw 2vw;background-position: center center;}
.pre:hover{width:2.5vw;height:2.5vw;border:#e0e0e0 dotted 1px;float:left;box-sizing:border-box;background: #fff;
background-image: url(../../assets/images/pre1.png);background-size: 2vw 2vw;background-position: center center;background-color: #3268ff;}
.pre1{width:2.5vw;height:2.5vw;border:#e0e0e0 dotted 1px;float:left;box-sizing:border-box;background: #fff;
background-image: url(../../assets/images/pre1.png);background-size: 2vw 2vw;background-position: center center;}


/*.next{width:2.5vw;height:2.5vw;border:#e0e0e0 dotted 1px;float:left;box-sizing:border-box;margin-left:1vw;background: #fff;}
.next img{width:2vw;margin-top:.25vw;margin-left:.25vw;}
.next:hover{background: #3268ff;}*/
.next{width:2.5vw;height:2.5vw;border:#e0e0e0 dotted 1px;float:left;box-sizing:border-box;margin-left:1vw;background: #fff;
background-image: url(../../assets/images/next1.png);background-size: 2vw 2vw;background-position: center center;}

.next:hover{width:2.5vw;height:2.5vw;border:#e0e0e0 dotted 1px;float:left;box-sizing:border-box;margin-left:1vw;background: #fff;
background-image: url(../../assets/images/next11.png);background-size: 2vw 2vw;background-position: center center;background-color: #3268ff;}
.next2{width:2.5vw;height:2.5vw;border:#e0e0e0 dotted 1px;float:left;box-sizing:border-box;margin-left:1vw;background: #fff;
background-image: url(../../assets/images/next2.png);background-size: 2vw 2vw;background-position: center center;}
 
.submits{width:12vw;height:4vw;background:#3268ff;margin-top:2vw;border-radius:.5vw;}
.submits span{display:block;float:left;width:8vw;text-align:center;color:#fff;font-size:1.4vw;line-height:4vw;}
.submits img{display:block;float:left;width:2vw;margin-top:1vw;height:2vw;}

.progress2{width:35vw;height:30vw;background:#fff;position:fixed;top:10vw;z-index:999999;left:32.5vw;border-radius:.5vw;overflow:hidden;}
.progress_hd2{width:100%;height:4vw;font-size:1.2vw;font-weight:bold;border-bottom:#ddd solid 1px;color:#333;}
.progress_hd2 span.ap{display:block;width:40%;margin-left:30%;float:left;line-height:4vw;text-align:center;font-size:1.6vw;}
.progress_hd2 img.cha{display:block;width:2vw;height:2vw;float:right;margin-top:1vw;margin-top:1vw;cursor:pointer;}

.progress2 span.ma1{display:block;width:100%;text-align:center;line-height:2vw;font-size:1.1vw;color:#999;margin-top:1vw;}
.progress2 span.ma2{display:block;width:100%;text-align:center;line-height:2vw;font-size:1.4vw;color:#333;margin-top:1vw;font-weight:bold;}
.ma_box{width:70%;margin:0 auto;height:3.5vw;margin-top:3vw;border-radius:.5vw;text-indent:1vw;}
.ma_box input{width:65%;float:left;border:#ebebeb solid 1px;height:3.5vw;font-size:1.1vw;color:#333;border-radius:.5vw;}
.ma_box button{width:30%;float:right;height:3.5vw;background:#f5f5f5;border:0;outline:none;font-size:1.1vw;border:#ddd solid 1px;border-radius:.5vw;}
.ma_box input::placeholder{text-indent:1vw;color:#999;font-size:1.1vw;}

.progress2 button.submits3{width:70%;margin:0 auto;height:3.5vw;background:#3465ff;display:block;margin-top:3vw;border:0;outline:none;
font-size:1.1vw;color:#ffff;border-radius:.5vw;}
.progress2 button.submits5{width:70%;margin:0 auto;height:3.5vw;background:#3465ff;display:block;margin-top:1vw;border:0;outline:none;
font-size:1.1vw;color:#ffff;border-radius:.5vw;}
.biao_list{width:70%;max-height:10vw;border:#ddd solid 1px;margin-top:1vw;scroll:no;overflow-y:auto;border-top-left-radius:.5vw;border-top-right-radius:.5vw;}
.biao_list ul{margin:0 auto;width:95%;}
.biao_list ul li{width:100%;height:2vw;margin-top:.5vw;}
.biao_list ul li img{display:block;width:2vw;float:left;}
.biao_list ul li span{display:block;width:20vw;float:left;line-height:2vw;font-size:1.1vw;color:#0F7A3E;text-overflow:ellipsis;white-space:nowrap;}
.biao_list b{padding-left: 1vw;text-decoration: underline;color: #f00;cursor: pointer;}


.biao_tj{width:70%;margin:0 auto;border:#ddd solid 1px;height:3vw;border-top:0;border-bottom-left-radius:.5vw;border-bottom-right-radius:.5vw;}
.biao_tj span{display:block;line-height:3vw;float:left;text-align:center;font-size:1vw;}
.biao_tj span.bio1{width:49%;border-right:#ddd solid 1px;box-sizing:border-box; }
.biao_tj span.bio2{width:50%;}
.biao_tj b{color:#FA9C3B;font-weight:normal;}


.progress{width:35vw;height:30vw;background:#fff;position:fixed;top:10vw;z-index:999999;left:32.5vw;border-radius:.5vw;overflow:hidden;}
.progress_hd{width:100%;height:4vw;line-height:4vw;text-align:center;font-size:1.2vw;font-weight:bold;border-bottom:#ddd solid 1px;color:#333;}

.jd{width:190px;height:190px;margin-top:3vw; }
.msg3{width:100%;margin:0 auto;line-height:3vw;font-size:1.2vw;text-align:center;font-weight:bold;color:#333;margin-top:1vw;}
.fjd{width:10vw;height:13vw;margin:0 auto;margin-top:3vw; }
.fjd img{display:block;margin:0 auto;width:10vw;}
.fjd span{display:block;height:3vw;line-height:3vw;text-align:center;font-size:1.4vw;color:#32AD37;}
.msg4{width:20vw;height:4vw;margin:0 auto;}
.msg4 span{display:block;text-align:center;font-size:1.1vw;line-height:2vw;}
.msg4 span.ms41{color:#333;}
.import_btns{width:16vw;height:3vw;margin:0 auto;margin-top:0;}
.import_btns button{display:block;width:7.5vw;height:3vw;outline:none;border:0;border-radius:.5vw;font-size:1vw;}
.import_btns button.a3{margin:0 auto; background:#3465ff;color:#fff;margin-top:0; }
</style>
<template>
	<div class="bgss">
	
	
	<transition name="draw">
			   <div class="mengban" v-show="progress_show"></div>
	       </transition>
		    <transition name="draw">
	       <div class="progress" v-show="progress_show">
		      <div v-if="mode==1">
				  <div class="progress_hd">一键发送</div>
				   <div class="jd">
					   <Progress
							  :transitionDuration="5000"
							  :radius="85"
							  :strokeWidth="10"
							  strokeColor="#3465ff"
							  :value="percent"
							>	   
					  </Progress>
				  </div>
			      <div class="msg3">短信发送中，请稍后</div>  
			   </div>
			   <div v-if="mode==2">
				  <div class="progress_hd">一键发送</div>
				   <div class="fjd">
					    <img src="../../assets/images/fjd.png">
						<span>发送完成</span>
				  </div>
			      <div class="msg4"><span class="ms41">{{count}}条发送任务已提交</span> </div>
				  <div class="import_btns">
				      
					 <button class="a3" @click="send_result()">查看结果</button>
				  </div>
			  </div>
		   </div>
	    </transition>
	
	
	
	
	
	
	
	       <transition name="draw">
			   <div class="mengban" v-show="onkey_show"></div>
	       </transition>
		   <transition name="draw">
	       <div class="progress2" v-show="onkey_show">
				  <div class="progress_hd2"><span class="ap">一键发送</span><img @click="close_onkey()" class="cha" src="../../assets/images/cha.png"></div>
				  <span class="ma1">请确认需要发送的数据表</span>  
				  <div class="biao_list">
				     <ul>
					 <div v-for="item in list2">
					    <li v-if="item.on==1"><img src="../../assets/images/excel.png"><span>{{item.name}}<b @click="send_view(item.id)">预览</b></span></li>
						 </div>
					 </ul>
				  </div>
				  <div class="biao_tj">
				     <span class="bio1">已选数据表：{{selected_files}}</span>
					 <span class="bio2">数据总条数：<b>{{selected_items}}</b></span>
				  </div>
			      
				  <button class="submits5" @click="sure5()">确定</button>
		   </div>
	      </transition>
		  
		  
		  
		  
		   <transition name="draw">
			   <div class="mengban" v-show="safe_show"></div>
	       </transition>
		   <transition name="draw">
	       <div class="progress2" v-show="safe_show">
				  <div class="progress_hd2"><span class="ap">发送安全码</span><img @click="safe_close()" class="cha" src="../../assets/images/cha.png"></div>
				  <span class="ma1">安全码将发送到当前账号绑定的手机</span>  
				  <span class="ma2">{{phone}}</span>  
			      <div class="ma_box">
				      <input type="text" placeholder="请输入安全码" v-model="code">
					  <button id="send" @click="send()">获取安全码</button>
				  </div>
				  <button class="submits3" @click="sure3()">确定</button>
		   </div>
	      </transition>
		  
		  
		  
		  
		  
		  
		  
		  
		  
	     <u_center  ></u_center>
	     <div class="top_area">
		    <img  @click="back()" src="../../assets/images/home_icon.png">
			<div class="tabbar7">
			   <span class="pos">您的当前位置:</span>
			   <span class="floder">数据仓库</span>
			   <span class="rights"></span>
			   <span class="floder">选择短信模板</span>
			</div>
		 </div>
		 <div class="steps">
		      <ul>
			     <li :class="item.class" v-for="item in steps" @click="step(item.id)">{{item.name}}</li> 
			  </ul>
			  <div class="new_template4" @click="add_template()">
			     <img src="../../assets/images/sms_code.png">
				 <span>新增短信模板</span>
			  </div>
		 </div>
		 <div class="templates">
		    <div v-for="item in list" >
              <div class="template_box2" :class="item.class" @click="choose(item.id)">
			      
				   <div v-if="item.status==1">
				       <p >{{item.content}}</p>
					   <div class="pass"><img src="../../assets/images/gou.png"></div>
					   <span class="msg1">审核通过</span>
					   <span class="edit">修改</span>
					   <span class="del">删除</span>
				   </div>
				   <div v-else>
				       <p style="color:#ccc">{{item.content}}</p>
					   <div class="pass" style="background:#f8b874;"> <img src="../../assets/images/tan.png"></div>
					   <span class="msg2">审核中</span>
					   <span class="edit" style="color:#ccc">修改</span>
					   <span class="del" style="color:#ccc">删除</span>
				   </div>
			  </div>
			 </div>
		 </div>
		 
		 <div class="pages">
		   <!--  <div class="pre" @click="prev()"  >
			   <img ref="pre"  src="https://anyunxin-sms.oss-cn-chengdu.aliyuncs.com/pre1.png">
			</div>
			<div class="next" @click="next()" >
			   <img ref="next" src="https://anyunxin-sms.oss-cn-chengdu.aliyuncs.com/next1.png">
			</div> -->
              <div class="pages">
		 	<div class="pre1"  v-if="page<total_page"></div>
		     <div class="pre" @click="prev()"   v-else></div>
		    

			<div class="next" @click="next()" v-if="page<total_page"></div>
			<div class="next2" @click="next()" v-else></div>
		 </div>

		 </div>
		 <div class="submits" @click="nextstep()">
		     <span>发送短信</span>
			 <img src="../../assets/images/more.png">
		 </div>
	</div>
</template>
<script>
import u_center from '@/components/u_center.vue'; 
import Progress from "easy-circular-progress";
	export default {
	    components: {
		  u_center,
		  Progress
	    },
		data() {
			return {
				steps:[],
				list:[],
				list2:[],
				token:"",
				type:"",
				page:1,
				total_page:"1",
				template:"",
				progress_show:false,
				 onkey_show:false,
				 safe_show:false,
				 mode:2,
				 selected_items:0,
				 selected_files:0,
				 phone:"",
				 code:"",
				 percent:0,
				 count:0,
				 task_id:"",
			}
		},
		mounted() {
		     let self=this;
		      var token= localStorage.getItem("token");
			  if(!token){
					 self.$router.push("/");  
			  }else{
			      self.token=token;
				  var list2=localStorage.getItem("file_list");
                      self.list2=JSON.parse(list2);			  
				  self.get_sms_type();
				  self.get_user_info();
			  }  
			 
			
		},
		methods: {
		    send_view(id){
                  this.$router.push("/send_view?template_id="+this.template+"&id="+id);  
		    },
		    add_data(){
			  this.$router.push("/import_data");  
			},
		    home(){
			  this.$router.push("/");  
			},
			 send(){
								  let self=this;
										axios.post(this.$api+'/home/send_safe_code', {
										   token: self.token
										  }).then(function (response) {  
						
										  let data=response.data;
									 
										  if(data.state==1){
										  
											 var countdown=60; 
											 function settime(){    

													   if (countdown > 0) {
																	 document.getElementById("send").setAttribute("disabled",true);
																	
																	 document.getElementById("send").innerHTML = "重新发送"+countdown;
																	  countdown--; 

														 } else if(countdown == 0)   { 

																	 countdown=null;
																	 document.getElementById("send").setAttribute("disabled",false);
																	
																	 document.getElementById("send").innerHTML = "获取验证码";
																	 return ;

														 } else{

																				 return;

															  }
											  }
												setInterval(function() { settime() },1000) 	 
										  }else{
											 self.$toast.center(data.msg);
										  }
									 
									  }).catch(function (error) {
											   
									  });
			},
		  get_user_info(){	        
		      let self=this;
		      axios.post(this.$api+'/home/get_user_info', {
					   token:self.token
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){                
					 self.phone=data.data.safe_phone; 				 
				  } 
		      }).catch(function (error) {
			         
		      });
		  },sure3(){
		      let self=this;
		      axios.post(this.$api+'/home/check_safe_code', {
					   token:self.token,
					   code:self.code
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){      
						var new_list=[];
						var files=0;			
						self.list2.forEach(function(obj,index){
							if(obj.on==1){
								new_list[index]=obj;
								files++;
							}
						});
						if(files==0){
						   self.$toast.center('请选择发送文件');
						   return;
						}else{
						  self.safe_show=false;
                          self.progress_show=true;
                          self.mode=1;	
                          self.send_sms(new_list);	
					 	}


				
					  				  
				  }else{
				     self.$toast.center(data.msg);
				  } 
		      }).catch(function (error) {
			         
		      });
		  },send_sms(list){
			    let self=this;
 
				axios.post(this.$api+'/message/send_sms', {
					   token:self.token,
					   list:JSON.stringify(list),
					   template_id:self.template
		       }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){                
					   self.percent=100;
                       self.count=data.data.count;
                       self.task_id=data.data.task_id;					   
					   setTimeout(function(){
						 self.mode=2;
					   },5000);
				  }else{
					   self.$toast.center(data.msg);
                       self.percent=0;							
				  } 
		       }).catch(function (error) {
			          
		       });

			   
			}, 
		  safe_close(){
		     this.safe_show=false;
		  },
		  sure5(){
		    this.onkey_show=false;
			this.safe_show=true;
		  },
		  close_onkey(){
		     this.onkey_show=false;
		  },
		  nextstep(){
		        var count=0;
                let self=this;	
                    self.selected_files=0;	
                    self.selected_items=0;					
				this.list2.forEach(function(obj,index){
					 
					if(obj.on==1){
					   count++
					   self.selected_files++;
					   self.selected_items=self.selected_items*1+obj.success*1;
					}
					 
				});
				if(count==0){
				   self.$toast.center('请选择数据');
				}else{
				   this.onkey_show=true;
				} 
		  },
		  send_result(){
		     this.$router.push("/send_result?task_id="+this.task_id);  
		  },
		    back(){
		      this.$router.push("/");  
		   },
		   
		   next(){
		      if(this.page<this.total_page){
			     this.page=this.page+1;
			     this.get_sms_template();
				 if(this.page==this.total_page){
				  // this.$refs.next.src='https://anyunxin-sms.oss-cn-chengdu.aliyuncs.com/next2.png'
				   if(this.total_page>1 &&  this.page>1){
				   //  this.$refs.pre.src='https://anyunxin-sms.oss-cn-chengdu.aliyuncs.com/pre2.png'
				   }
				 }
			  }else if(this.total_page>1 && this.page>1){
				     this.$refs.pre.src='https://anyunxin-sms.oss-cn-chengdu.aliyuncs.com/pre2.png'
			  } 
			     
			   
		   },prev(){
		      if(this.page>1){
			     this.page=this.page-1;
			     this.get_sms_template();
				 if(this.page==1){
				  // this.$refs.pre.src='https://anyunxin-sms.oss-cn-chengdu.aliyuncs.com/pre1.png'
				   if(this.total_page>1 &&  this.page<this.total_page){
				   //  this.$refs.next.src='https://anyunxin-sms.oss-cn-chengdu.aliyuncs.com/next1.png'
				   }
				 }
			  }
		   },
		   add_template(){
		   	 var code ="" ;
			 for(var i=0;i<6;i++){
				var radom = Math.floor(Math.random()*10);
				code += radom;
			  }
		      this.$router.push("/select_add?code="+code);  
		   },
		   get_sms_type(){	        
		      let self=this;
		      axios.post(this.$api+'/message/get_sms_type', {
					   token:self.token
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){                
					 self.steps=data.data;	
					 console.log(self.steps)
					 if(self.steps[0]){
					    self.steps[0].class='on';
						self.type=self.steps[0].id;
						 self.get_sms_template();
					 }				 
				  }else if(data.state==3){                
					 self.$router.push("/");  		 
				  } 
		      }).catch(function (error) {
			         
		      });
		  },
		  get_sms_template(){	        
		      let self=this;
		      axios.post(this.$api+'/message/get_sms_template', {
					   token:self.token,
					   type:self.type,
					   page:this.page
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){                
					 self.list=data.data.list;
                     self.total_page=	data.data.total_page;				 
				  }else if(data.state==3){                
					 self.$router.push("/");  		 
				  } 
		      }).catch(function (error) {
			         
		      });
		  },
		   step(id){
		        var new_list=[];                   
				this.steps.forEach(function(obj,index){
					new_list[index]=obj;
					if( obj.id==id){
						new_list[index].class='on';
					}else{
					    new_list[index].class='';
					}
				});
			    this.steps=new_list;
				this.type=id;
				this.page=1;
				this.$refs.next.src='https://anyunxin-sms.oss-cn-chengdu.aliyuncs.com/next1.png'
				this.$refs.pre.src='https://anyunxin-sms.oss-cn-chengdu.aliyuncs.com/pre1.png'
				this.get_sms_template();
		   },choose(id){
		        var new_list=[];                   
				this.list.forEach(function(obj,index){	
					new_list[index]=obj;
					if( obj.id==id){
					    if(obj.status==1){
						   new_list[index].class='selected';
						}
					}else{
					    new_list[index].class='';
					}
					
				});
			    this.list=new_list;
				this.template=id;
		   }
		},watch:{
			 
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/sms/select_template_store.vue